import { render, staticRenderFns } from "./control.vue?vue&type=template&id=3c4ff2fe&scoped=true&"
import script from "./control.vue?vue&type=script&lang=js&"
export * from "./control.vue?vue&type=script&lang=js&"
import style0 from "./control.vue?vue&type=style&index=0&id=3c4ff2fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ff2fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c4ff2fe')) {
      api.createRecord('3c4ff2fe', component.options)
    } else {
      api.reload('3c4ff2fe', component.options)
    }
    module.hot.accept("./control.vue?vue&type=template&id=3c4ff2fe&scoped=true&", function () {
      api.rerender('3c4ff2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customPage/control.vue"
export default component.exports